import React, { useState, useEffect } from "react";
import "../assets/css/Navbar.css";
import { NavLink, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { GrTechnology } from "react-icons/gr";
import { CgLogOut } from "react-icons/cg";
import { logoutUser } from "../services/apiServices";
import "@fontsource/poppins";
export default function Navbar() {
  const [authUser, setAuthUser] = useState(false);

  useEffect(() => {
    const role = localStorage.getItem("role");
    if (role == "superadmin") {
      setAuthUser(true);
    }
  }, []);
  const navigate = useNavigate();
  const handleResults = async (e) => {
    let token = localStorage.getItem("token");
    if (!token) {
      e.preventDefault();
      toast.error("You are not logged in! Redirecting to login...");
      setTimeout(() => {
        navigate("/");
      }, 1500);
    } else {
      try {
        // Fetch the results from the API
        navigate("/results");
      } catch (error) {
        console.error("Error fetching past results:", error);
        toast.error("Failed to fetch past results Please try again later.");
      }
    }
  };
  const handleLogout = async () => {
    try {
      const email = localStorage.getItem("email");
      const loginTime = localStorage.getItem("loginTimestamp");
      if (email) {
        const response = await logoutUser(email);
        if (response.logoutTimestamp) {
          // Calculate session duration if we have both timestamps
          if (loginTime) {
            const sessionDuration =
              new Date(response.logoutTimestamp) - new Date(loginTime);
            const minutes = Math.floor(sessionDuration / (1000 * 60));
            const seconds = Math.floor((sessionDuration % (1000 * 60)) / 1000);
          }
        }
      } else {
        console.error("No email found in localStorage, skipping API call");
      }
    } catch (err) {
      console.error("Error during logout:", err);
    } finally {
      localStorage.removeItem("token");
      localStorage.removeItem("email");
      localStorage.removeItem("user");
      localStorage.removeItem("loginTimestamp");
      localStorage.clear();
      navigate("/");
    }
  };
  return (
    <header className="navbar-wrap">
      <ToastContainer />
      <div className="navbar">
        <div className="logo-container">
          <GrTechnology className="logo" />
          NTD Monitor
        </div>
        <nav>
          <NavLink
            to="/ethiopia"
            className={({ isActive }) => (isActive ? "active" : "")}
          >
            Home
          </NavLink>
          <NavLink
            to="/map"
            className={({ isActive }) => (isActive ? "active" : "")}
          >
            Map
          </NavLink>
          {authUser == true && (
            <NavLink
              to="/user-management"
              className={({ isActive }) => (isActive ? "active" : "")}
            >
              Users
            </NavLink>
          )}
          {/* <NavLink
            to="/results"
            onClick={handleResults}
            className={({ isActive }) => (isActive ? "active" : "")}
          >
            Records
          </NavLink> */}
          <CgLogOut className="logout" onClick={handleLogout} />
        </nav>
      </div>
    </header>
  );
}
